import { FileTopic } from '~/types/theory'

import { organizationSchema } from './Schema.util'

import Schema from './Schema'

interface Props {
  topic: FileTopic
  articleBody: string
}

function createSchemaObject({ topic, articleBody }: { topic: FileTopic; articleBody: string }): any {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: topic.h1,
    image: topic.image ? [topic.image.url] : [topic.previewUrl],
    description: topic.metaDescription,
    articleBody,
    // lastmod is the pipeline's real content-modification date (same date that feeds the sitemap).
    // Omit dateModified when absent — a fabricated date is a false freshness signal.
    ...(topic.lastmod ? { dateModified: topic.lastmod } : {}),
    isAccessibleForFree: true,
    // No per-article author data exists, so the honest author is the Organization —
    // upgrade to a staff Person (/our-team) once the pipeline exports authorship.
    author: organizationSchema,
    publisher: organizationSchema,
  }
}

const ArticleSchema = ({ topic, articleBody }: Props): React.ReactElement => {
  const schemaObject = createSchemaObject({ topic, articleBody })

  return <Schema schemaObject={schemaObject} />
}

export default ArticleSchema
